module.exports = __webpack_public_path__ + "img/5035767.jpg";